var { parsePhoneNumberFromString } = require("libphonenumber-js/mobile");

const validateMobile = () => {
  var $mobileInputGroup = $("#mobile-input-group");
  var $mobileInput = $("#mobile");

  // Remove invalid phone number characters on input
  $mobileInput.on("input", function () {
    var originalValue = $(this).val();
    var prefix = "";

    // Plus is allowed only as the first character (will be replaced with 00)
    if (originalValue.substr(0, 1) === "+") {
      prefix = "+";
    }

    $(this).val(
      prefix +
        $(this)
          .val()
          .replace(/[^0-9]/g, "")
    );
  });

  const parseMobileNumber = () =>
    parsePhoneNumberFromString($mobileInput.val(), FPRE.country.toUpperCase());
  // Normalize swiss phone number and validate on change
  $mobileInput.on("blur", function () {
    // Normalize phone number
    const phoneNumber = parseMobileNumber();
    // We reformat the number only if we found a valid mobile number, otherwise we leave the original, invalid input
    if (phoneNumber.isValid()) {
      $(this).val(phoneNumber.number.toString().replace("+", "00"));
    }
    $mobileInputGroup.trigger("validate");
  });

  // Custom validation event
  $mobileInputGroup.on("validate", function () {
    const phoneNumber = parseMobileNumber();
    // $mobileInput.getValidity checks only the pattern and required attributes on the input field
    $(this).setValidityClass(
      $mobileInput.getValidity() && phoneNumber.isValid()
    );
  });
};

export { validateMobile };
